import { Form, FormItemProps,Input as AntdInput } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import type { Rule } from "antd/es/form";
import * as React from "react";

import { SizeEnum } from "@/types";
import { REQUIRED_VALIDATION_MESSAGE } from "@/utils/constant";
import classNames from "clsx";
interface TextAreaInputProps extends FormItemProps {
  name: string;
  label: string;
  placeholder: string;
  size?: SizeEnum;
  minRows?: number;
  required?: boolean;
  disabled?: boolean;
  onChangeListener?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isSeperator?: boolean
}

export const TextAreaInput = ({
  name,
  label,
  placeholder,
  size = SizeEnum.large,
  minRows = 1,
  required = false,
  onChangeListener,
  rules = [],
  isSeperator,
  ...rest
}: TextAreaInputProps) => {
  const getRules = (): Rule[] => {
    return [...rules, { required, message: REQUIRED_VALIDATION_MESSAGE }];
  };

  return (
    <div className={classNames(
      "custom_form_comp_wrapper",
      rest?.hidden && "h-0 overflow-hidden",
      isSeperator && "flex items-center gap-x-2"
    )} >
      {label && (
        <label
          htmlFor={name}
          className={classNames(
            "block text-primary-0",
            isSeperator ? "mb-6" : "mb-2"
          )}
        >
          {label}
        </label>
      )}
      {isSeperator && (
        <div className="mb-6 flex-[1] basis-40 border border-dashed border-disabled" />
      )}
      <div className="basis-[288px]">
        <Form.Item name={name} rules={getRules()} {...rest}>
          <AntdInput.TextArea
            size={size as SizeType}
            autoSize={{
              minRows,
            }}
            placeholder={placeholder}
            disabled={rest?.disabled}
            onChange={onChangeListener}
            className="bg-neutral-150 text-sm placeholder:text-[#62748E80]/80 border-[#F8FAFC] focus:border-primary-500"
          />
        </Form.Item>
      </div>
    </div>
  );
};
